import { useMemo } from 'react';
import { APIType } from '~/backend/types';
import { Modality } from '~/domain/dicom/modality';
import { isIsroModel } from '~/hooks/workflows/isro/isroSamples';
import {
    compareLatestFirst,
    PredictionModel,
} from '~/utils/transforms/predictionModelsDataTransforms';
import { useBackendModels } from '../useBackend';

// None until the input modality is known: a model is never offered for a guessed one.
export function useImageTranslationModels(
    modality: Modality | undefined
): PredictionModel[] {
    const { data: models } = useBackendModels(APIType.TRANSLATION);
    return useMemo(
        () =>
            modality
                ? (models ?? [])
                      // One synthetic image per run: a multi-sample model has no single result to use.
                      .filter(
                          (model) =>
                              model.inputModalities?.includes(modality) &&
                              !isIsroModel(model)
                      )
                      .sort(compareLatestFirst)
                : [],
        [models, modality]
    );
}
